export default {"src":"/_next/static/media/Elephant.63a49756.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};